































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import ReturObatNarkotikaDetail from "./ReturObatNarkotikaDetail.vue";

@Component({
  components: { ReturObatNarkotikaDetail }
})
export default class ReturObatItemDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) editItem!: any;

  formValid = false;
  menuExpired = false;

  form: any = this.getEmptyForm();
  narkotikaDetail = { jumlah_terpakai: null, jumlah_sisa_dibuang: null };

  kategoriOptions = [
    { value: "obat", text: "Obat" },
    { value: "cairan", text: "Cairan" },
    { value: "alkes", text: "Alkes" },
    { value: "narkotika", text: "Narkotika" },
    { value: "nutrisi", text: "Nutrisi" },
  ];

  kondisiOptions = [
    { value: "utuh", text: "Utuh" },
    { value: "terbuka_layak", text: "Terbuka (Layak)" },
    { value: "terbuka_tidak_layak", text: "Terbuka (Tidak Layak)" },
    { value: "expired", text: "Expired" },
    { value: "rusak", text: "Rusak" },
  ];

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  get isKondisiTerbuka() {
    return ["terbuka_layak", "terbuka_tidak_layak"].includes(this.form.kondisi);
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editItem) {
        this.form = { ...this.editItem };
        this.narkotikaDetail = {
          jumlah_terpakai: this.editItem.jumlah_terpakai,
          jumlah_sisa_dibuang: this.editItem.jumlah_sisa_dibuang,
        };
      } else {
        this.form = this.getEmptyForm();
        this.narkotikaDetail = { jumlah_terpakai: null, jumlah_sisa_dibuang: null };
      }
    }
  }

  getEmptyForm() {
    return {
      kategori: "",
      nama_item: "",
      kekuatan_sediaan: "",
      bentuk_sediaan: "",
      satuan: "",
      jumlah_retur: null,
      kondisi: "utuh",
      keterangan: "",
      batch_no: "",
      expired_date: null as string | null,
      is_high_alert: false,
      is_narkotika: false,
      harga_satuan: null,
      obat_id: null,
      resep_obat_item_id: null,
    };
  }

  close() {
    this.dialogVisible = false;
  }

  save() {
    const data = { ...this.form };

    if (data.is_narkotika && this.isKondisiTerbuka) {
      data.jumlah_terpakai = this.narkotikaDetail.jumlah_terpakai;
      data.jumlah_sisa_dibuang = this.narkotikaDetail.jumlah_sisa_dibuang;
    }

    // Auto-set kategori to narkotika if checked
    if (data.is_narkotika && data.kategori !== "narkotika") {
      data.kategori = "narkotika";
    }

    this.$emit("save", data);
  }
}
